import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-action-router-link',
  templateUrl: './action-router-link.component.html',
  styleUrls: ['./action-router-link.component.scss']
})
export class ActionRouterLinkComponent implements OnInit {

  @Input() actionRouterLink: any[] | string;
  @Input() buttonClass: string | string[] | Set<string> | { [klass: string]: any; };

  constructor() {

  }

  ngOnInit() {
  }

}
@NgModule({
  declarations: [ActionRouterLinkComponent],
  imports: [
    CommonModule,
    RouterModule,
    LinkModule,
  ],
  exports: [ActionRouterLinkComponent]
})
export class ActionRouterLinkModule { }
